module.exports = __webpack_public_path__ + "static/media/banner-slide-2.7e8a742a.jpg";